/** Save once the user has been quiet this long. */
export const QUIET_MS = 3000;
/** Long unbroken typing still saves this often. */
export const MAX_UNSAVED_MS = 30000;
/**
 * A cell edit left open this long is saved anyway. Exporting commits it, so
 * typing after this point starts the cell afresh; that beats holding unsaved
 * work indefinitely when we've merely misread the edit state.
 */
export const OPEN_CELL_EDIT_MS = 60000;

export function shouldAutosave(s: {
  now: number;
  lastInputAt: number;
  dirtySince: number;
  cellEditing: boolean;
}): boolean {
  const quiet = s.now - s.lastInputAt;
  if (s.cellEditing) return quiet >= OPEN_CELL_EDIT_MS;
  return quiet >= QUIET_MS || s.now - s.dirtySince >= MAX_UNSAVED_MS;
}
